/**
 * Set Environment Configuration
 *
 */

const AppSettings = {}

export default AppSettings
